// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__34M8e","row":"ProcedureTreatmentSummary_row__1UpVV"};